import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
    const { t } = useTranslation();

    return (
        <Grid className="not-found-container" container item rowGap={2} direction="column" justifyContent="center" alignItems="center" height="100vh">
            <Grid component="h1" sx={{ color: "var(--primary-color)", fontSize: "6rem" }}>
                404
            </Grid>
            <Grid component="p" sx={{ color: "var(--gray-color)", fontSize: { xs: "1.25rem", md: "1.5rem" }, textAlign: "center" }}>
                {t("Messages.Page Not Found")}
            </Grid>
            <Link
                to="/"
                style={{
                    padding: "0.75rem 1.5rem",
                    fontSize: "1rem",
                    color: "var(--light-color)",
                    backgroundColor: "var(--primary-color)",
                    border: "none",
                    borderRadius: "5px",
                    textDecoration: "none",
                    transition: "background-color 0.3s ease",
                    "&:hover": {
                        backgroundColor: "var(--primary-color-40)",
                    },
                }}
            >
                {t("backToHomePage")}
            </Link>
        </Grid>
    );
};

export default NotFoundPage;
